<template>
  <div
    ref="container"
    class="study-combos anim-fade-in text-noselect large-scroll-track"
    :class="[
      gridClass,
      maximized ? 'study-combos_column' : '',
      { 'study-combos_zoomable': hasZoom },
    ]"
    @mouseleave="isometricBucket = null"
  >
    <HandTableCell
      v-for="(item, index) in hands"
      :id="`${idPrefix || player}_${item.id}`"
      :key="item.id"
      :data-tst="`${idPrefix || player}_${index}`"
      class="study-combos_cell"
      :class="handcssClass"
      :gameformat="gameformat"
      :combo="item"
      :comboPlayer="(item.players && item.players[player]) || item[player]"
      :player="player"
      :asEmpty="asEmpty"
      :hasLegend="hasLegend"
      :showBetsIn="showBetsIn"
      :bettingInfo
      :showProp="showProp"
      :evProps="evProps"
      :showFlopContent="showFlopContent"
      :grouping="grouping"
      :isDimmed="
        (customHandsIds && !customHandsIds.includes(item.id)) ||
        (isometricBucket &&
          isometricBucket[0] !== item.id &&
          isometricBucket[1] !== item.isometric_bucket)
      "
      :isLocked="canBeLocked && item.is_locked"
      :maximized="maximized"
      :maximizible="combosMaximizible"
      :hasPremiumGameformat="hasPremiumGameformat"
      :rangeKey="rangeKey"
      :filterEvCompare="filterEvCompare"
      :viewProps="viewProps"
      :rangeTab="rangeTab"
      :useHex="useHex"
      :hasBlockers="hasBlockers"
      :filterCombos="filterCombos"
      @maximize="() => (sw_combos_expand = !sw_combos_expand)"
      @click="vals => $emit('click', vals)"
      @mouseenter="handleMouseenter"
      @mousedown="vals => $emit('mousedown', vals)"
      @click:blocker="() => $emit('click:blocker')"
    />
    <!-- :isDimmed="customHandsIds && !customHandsIds.includes(item.id)"
      :isOutlined="
        highlightIsoBucket && isometricBucket && isometricBucket === item.isometric_bucket
      " -->
  </div>
</template>

<script>
import HandTableCell from '@/components/Study/HandTableCell'

export default {
  name: 'StudyCombos',
  components: {
    HandTableCell,
  },
  props: {
    namespace: String,
    group: Object,
    player: String,
    idPrefix: String,
    customHandsIds: Array,
    customFntSize: Number,
    canBeLocked: { type: Boolean, default: true },
    hasZoom: { type: Boolean, default: true },
    hasLegend: { type: Boolean, default: true },
    handcssClass: { default: () => '' },
    combosMaximizible: { type: Boolean, default: true },
    viewProps: Object,
    filterCombos: Object,
    filterEvCompare: Object,
    evProps: Object,
    mobile: Boolean,
    grouping: String,
    showBetsIn: String,
    bettingInfo: Object,
    rangeKey: String,
    showProp: String,
    hasBlockers: { type: Boolean, default: true },
    asEmpty: Boolean,
    showFlopContent: Boolean,
    useHex: Boolean,
    hasPremiumGameformat: Boolean,
    gameformat: Object,
    rangeTab: String,
    highlightIsoBucket: Boolean,
  },
  emits: ['click', 'mousedown', 'click:blocker', 'mouseenter'],
  data() {
    return {
      sw_combos_expand: false,
      isometricBucket: null,
    }
  },
  created() {
    this.resetMaximize()
  },
  methods: {
    handleMouseenter(vals) {
      this.$emit('mouseenter', vals)
      if (this.highlightIsoBucket) {
        this.isometricBucket = [vals.combo.id, vals.combo.isometric_bucket]
      }
    },
    resetMaximize() {
      if (!this.combosMaximizible) return
      this.sw_combos_expand = false
    },
  },
  computed: {
    hands() {
      return this.group?.combos || []
    },
    gridClass() {
      return `items_${this.hands.length || 0}`
    },
    maximized() {
      return this.combosMaximizible && this.sw_combos_expand
    },
  },
  watch: {
    hands: {
      // setImmediate: true, // for some reason this does not fire
      // when StudyCombos are used in TabBox moved to created() instead
      setImmediate: false,
      handler: 'resetMaximize',
    },
  },
}
</script>

<style lang="scss">
.study-combos {
  position: relative;
  display: grid;

  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 4px;

  border: solid var(--clr-black-0) 1px;
  --active-size-width: 175%;
  --active-size-height: 175%;

  &_cell {
    --htc-radius: 4px;
    --bb-radius: 0px;
    --overflow-height: calc(100% - var(--active-size-height));
    --overflow-width: calc(100% - var(--active-size-width));
    outline: 1px solid var(--clr-black-0);
    top: 0;
    left: 0;
    z-index: 0;
    border-radius: var(--bb-radius);

    &:nth-child(2):nth-last-child(3) {
      --bb-radius: 0px var(--htc-radius) 0px 0px;
    }
    &:nth-child(3):nth-last-child(2) {
      --bb-radius: 0px 0px 0px var(--htc-radius);
    }
    &:nth-child(3):nth-last-child(4) {
      --bb-radius: 0px var(--htc-radius) 0px 0px;
    }
    &:nth-child(4):nth-last-child(3) {
      --bb-radius: 0px 0px 0px var(--htc-radius);
    }
    &:nth-child(3):nth-last-child(10) {
      --bb-radius: 0px var(--htc-radius) 0px 0px;
    }
    &:nth-child(10):nth-last-child(3) {
      --bb-radius: 0px 0px 0px var(--htc-radius);
    }
    &:first-child {
      --bb-radius: var(--htc-radius) 0px 0px 0px;
    }
    &:last-child {
      --bb-radius: 0px 0px var(--htc-radius) 0px;
    }
  }

  width: 100%;
  height: 100%;
  flex: 1;
  &_column {
    display: block !important;
  }
  &_simple {
    .htc {
      min-height: 3rem !important;
    }
    .htc_graph_legend,
    .htc_value {
      display: none !important;
    }
  }
}

@media (pointer: fine) {
  .study-combos {
    &_cell {
      @keyframes maximizeHtc {
        0% {
          height: 100%;
          width: 100%;
          top: 0;
          left: 0;
          box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.55);
          z-index: 0;
          border-radius: var(--bb-radius);
        }
        60% {
          height: 100%;
          width: 100%;
          top: 0;
          left: 0;
          box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.55);
          z-index: 0;
        }
        100% {
          height: var(--active-size-height);
          width: var(--active-size-width);
          box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.55);
          z-index: 2;
          border-radius: 4px;
        }
      }
      @keyframes maximizeHtcDelayed {
        0% {
          height: 100%;
          width: 100%;
          top: 0;
          left: 0;
          box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.55);
          z-index: 0;
          border-radius: var(--bb-radius);
        }
        90% {
          height: 100%;
          width: 100%;
          top: 0;
          left: 0;
          box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.55);
          z-index: 0;
        }
        100% {
          height: var(--active-size-height);
          width: var(--active-size-width);
          box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.55);
          z-index: 2;
          border-radius: 4px;
        }
      }
    }

    &_zoomable {
      --zoom-duration: 0.6s;
      .study-combos_cell {
        &:hover {
          &:not(.htc_maximized) {
            animation: maximizeHtc var(--zoom-duration);
          }
        }
      }
      &.study-combos_cell_zoom-delayed {
        &:hover {
          &:not(.htc_maximized) {
            animation: maximizeHtcDelayed var(--zoom-duration);
          }
        }
      }
      .study-combos_cell {
        &:hover {
          &:not(.htc_maximized) {
            z-index: 2;
            overflow: hidden;
            border-radius: 4px;
            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.55);
            height: var(--active-size-height);
            width: var(--active-size-width);
            top: calc(var(--overflow-height) / 2);
            left: calc(var(--overflow-width) / 2);

            // 4items
            &:nth-child(2):nth-last-child(3) {
              top: 0;
              left: var(--overflow-width);
            }
            &:nth-child(3):nth-last-child(2) {
              top: var(--overflow-height);
              left: 0;
            }

            // 6items
            &:nth-child(2):nth-last-child(5),
            &:nth-child(3):nth-last-child(4) {
              top: 0;
            }
            &:nth-child(3):nth-last-child(4) {
              left: var(--overflow-width);
            }
            &:nth-child(4):nth-last-child(3) {
              top: var(--overflow-height);
              left: 0;
            }
            &:nth-child(5):nth-last-child(2) {
              top: var(--overflow-height);
            }

            // 12items
            &:nth-child(2):nth-last-child(11),
            &:nth-child(3):nth-last-child(10) {
              top: 0;
            }
            &:nth-child(4):nth-last-child(9),
            &:nth-child(7):nth-last-child(6),
            &:nth-child(10):nth-last-child(3) {
              left: 0%;
            }
            &:nth-child(3):nth-last-child(10),
            &:nth-child(6):nth-last-child(7),
            &:nth-child(9):nth-last-child(4) {
              left: var(--overflow-width);
            }
            &:nth-child(10):nth-last-child(3),
            &:nth-child(11):nth-last-child(2),
            &:nth-child(12):nth-last-child(1) {
              top: var(--overflow-height);
            }
            &:first-child {
              top: 0;
              left: 0;
            }
            &:last-child {
              top: var(--overflow-height);
              left: var(--overflow-width);
            }
          }
        }
      }
    }
  }
}

.items_4 {
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  --active-size-width: 125%;
  --active-size-height: 125%;
}
.items_6 {
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  --active-size-width: 175%;
  --active-size-height: 125%;
}
.items_12 {
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(4, 1fr);
  --active-size-width: 175%;
  --active-size-height: 200%;
}
</style>
